module.exports = __webpack_public_path__ + "../resources/images/compactSelected-615c95ce444661f49eaedd3edb0fe0ec.svg";